// extracted by mini-css-extract-plugin
export default {"mid-box":"MembershipComplete_mid-box__D4caY","top":"MembershipComplete_top__+Ei15","mid":"MembershipComplete_mid__blbLd","botm":"MembershipComplete_botm__6TJuL"};